import React from 'react'
import Masonry from 'react-masonry-component'

import MiniatureGear from './MiniatureGear'
import MiniatureGearV2 from './MiniatureGearV2'
import GuarantyCalculatorGear from '../../guarantycalculator/components/GuarantyCalculatorGear'
import VisBrowser from '../../visbrowser/components/VisBrowser'
import AppraisalMiniGear from 'app/gears/appraiser/workspace/containers/AppraisalMiniGear'
import CondoBuilderContainer from 'app/gears/condo-builder/containers/CondoBuilderContainer'
import AnnouncementsGear from 'app/gears/announcements/containers/AnnouncementsGear'
import AdminMiniGear from 'app/gears/admin/components/AdminMiniGear'
import OversightMiniGear from 'app/gears/oversight/containers/OversightMiniGear'
import LoanSearchContainer from 'app/gears/lender/containers/LoanSearchContainer'
import { GEAR_URLs as LENDER_URLs, AUTHORIZATIONS as lenderAuthorizations } from 'app/gears/lender/actions/lenderConfig'

/** 
 * The gearbox is the home page of LGYHub, so called because it contains gears which are independent applets. The gearbox asks the gears to run in 
 * 'min mode', which is a smaller format, so all of the functionalities can fit on the screen. The user can expand these mini-gears to view the full 
 * pages.
 * 
 * @author Alex Clary
 * @author Nic Ebner
 */
export const Gearbox = ({ currentUser }) => {
  const authorizations = currentUser.id ? currentUser.authorizations : []
  // masonry is a library that implements the layout of the minigears. You can configure options here.
  const masonryOptions = {
    itemSelector: '.mini-gear',
    columnWidth: 1
  }

  return (
    <div className='gear-box'>
      <Masonry options={masonryOptions} enableResizableChildren={true}>
        <MiniatureGear name='Announcements' quadrupleWide doubleTall link='/lgyhub/announcements'>
          <AnnouncementsGear minMode />
        </MiniatureGear>

        {!Object.values(lenderAuthorizations).some(lenderAuthorization => !authorizations.includes(lenderAuthorization)) &&
          <MiniatureGearV2 name='Lender Workspace' quadrupleWide tripleTall link={LENDER_URLs.GEAR_BASE_PATH}>
            <LoanSearchContainer hardLink />
          </MiniatureGearV2>}

        {authorizations.includes('APPLICATION_Appraiser Portlet') &&
          <MiniatureGear name='Appraiser Workspace' quadrupleWide fitHeight link='/lgyhub/appraiser'>
            <AppraisalMiniGear currentUser={currentUser} />
          </MiniatureGear>}

        <MiniatureGear name='Condo Report' quadrupleWide doubleTall link='/lgyhub/condo-report'>
          <CondoBuilderContainer condo minMode />
        </MiniatureGear>

        <MiniatureGear name='Guaranty Calculator' quadrupleWide doubleTall link='/lgyhub/guaranty-calculator'>
          <GuarantyCalculatorGear minMode />
        </MiniatureGear>

        {authorizations.includes('VIS Browser') &&
          <MiniatureGear name='VIS Browser' quadrupleWide doubleTall link='/lgyhub/vis-browser'>
            <VisBrowser minMode />
          </MiniatureGear>}

        {(authorizations.includes('View Admin Gear')) && <AdminMiniGear />}

        {authorizations.includes('View Oversight Gear') &&
          <MiniatureGear name='Oversight' quintupleWide fitHeight link='/lgyhub/oversight'>
            <OversightMiniGear user={currentUser} />
          </MiniatureGear>}

        {authorizations.includes('View Funding Fee Refund Record') && 
          <MiniatureGear name='Funding Fee Refunds' doubleWide link='/lgyhub/funding-fee/refunds'>
            <h4>Funding Fee Refunds</h4>
            Refund processing
          </MiniatureGear>}
      </Masonry>
    </div>
  )
}

export default Gearbox
